import { useState } from 'react';

import { Toast as BaseToast } from '@base-ui/react/toast';
import styled from 'styled-components';

import { pxToRem } from '@utils/converters';

import { Toast } from './toast';
import { toastManager, ToastData } from './use-toaster';

export const Toaster = () => {
  const [paused, setPaused] = useState(false);

  // React 17 delegates events to #root, not document. base-ui's Toast.Portal
  // defaults to document.body (outside #root), so React never sees the viewport's
  // mouse events and pause-on-hover dies. Portal into #root instead.
  const portalContainer = document.getElementById('root') ?? document.body;

  return (
    <BaseToast.Provider toastManager={toastManager} timeout={0}>
      <BaseToast.Portal container={portalContainer}>
        <Viewport
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
          onFocus={() => setPaused(true)}
          onBlur={() => setPaused(false)}
          data-toaster-paused={paused || undefined}
        >
          <ToastList />
        </Viewport>
      </BaseToast.Portal>
    </BaseToast.Provider>
  );
};

const ToastList = () => {
  const { toasts } = BaseToast.useToastManager<ToastData>();
  return (
    <>
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} />
      ))}
    </>
  );
};

const VIEWPORT_WIDTH = 424;

const Viewport = styled(BaseToast.Viewport)({
  position: 'fixed',
  zIndex: 99999,
  bottom: '2rem',
  left: '50%',
  right: 'auto',
  top: 'auto',
  width: pxToRem(VIEWPORT_WIDTH),
  marginLeft: pxToRem(-VIEWPORT_WIDTH / 2),
});
